export default "__VITE_ASSET__mdFmlR1N__"